import {useFormContext} from "react-hook-form";

import {theme} from "Theme";
import {FileUtil} from "base/file/utilities";
import {FileLabel, FileSelectButton} from "base/file/components";

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import FormHelperText from "@mui/material/FormHelperText";
import UploadFileIcon from "@mui/icons-material/UploadFile";

const FileSelector = ({
    name,
    label,
    subLabel = "",
    uploadedFile,
    onChange,
    rules = {},
    maxSize,
    disabled = false,
    errors,
}) => {
    const {getValues, trigger} = useFormContext();

    const fileToUpload = getValues()[name];

    const handleSelectFiles = async file => {
        onChange(file);
        trigger([name]);
    };

    const getFileDetails = () => {
        if (fileToUpload?.name) {
            return `${fileToUpload.name} | ${FileUtil.formatBytes(fileToUpload.size)}`;
        } else if (uploadedFile?.name)
            return `${uploadedFile.name} | ${FileUtil.formatBytes(uploadedFile.size)}`;
        else return `Máx. ${FileUtil.formatBytes(maxSize)}`;
    };

    return (
        <>
            <Stack direction="row" alignItems="center">
                <UploadFileIcon sx={{color: theme.palette.primary.main}} />
                <Stack ml={2}>
                    <FileLabel label={label} subLabel={subLabel} />
                    <Typography
                        variant="caption"
                        color="textSecondary"
                        component="span"
                        lineHeight={1}
                    >
                        {getFileDetails()}
                        {errors[name] && (
                            <FormHelperText error>
                                {errors[name].message.toString()}
                            </FormHelperText>
                        )}
                    </Typography>
                </Stack>
            </Stack>
            <Stack direction="row" spacing={1}>
                <FileSelectButton
                    name={name}
                    text="Selecionar"
                    multiple={false}
                    onSelectFiles={handleSelectFiles}
                    rules={rules}
                    hideErrors
                    disabled={disabled}
                    style={{mt: 0}}
                />
            </Stack>
        </>
    );
};

export default FileSelector;
